/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ExternalProjectLinksControllerFindOneQueryResponse, ExternalProjectLinksControllerFindOnePathParams, ExternalProjectLinksControllerFindOneQueryParams, ExternalProjectLinksControllerFindOne400, ExternalProjectLinksControllerFindOne401, ExternalProjectLinksControllerFindOne403, ExternalProjectLinksControllerFindOne404 } from "../../models/externalProjectLinksController/ExternalProjectLinksControllerFindOne";

function getExternalProjectLinksControllerFindOneUrl(id: ExternalProjectLinksControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/external-project-links/${id}` as const }  
  return res
}

/**
 * @summary Get an external project link by ID
 * {@link /api/v1/external-project-links/:id}
 */
export async function externalProjectLinksControllerFindOne(id: ExternalProjectLinksControllerFindOnePathParams["id"], params?: ExternalProjectLinksControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ExternalProjectLinksControllerFindOneQueryResponse, ResponseErrorConfig<ExternalProjectLinksControllerFindOne400 | ExternalProjectLinksControllerFindOne401 | ExternalProjectLinksControllerFindOne403 | ExternalProjectLinksControllerFindOne404>, unknown>({ method : "GET", url : getExternalProjectLinksControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}